import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const DEPLETIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.DepletionType.Name')
    .required()
    .minLength(1)
    .maxLength(15)
    .build(),
  FieldBuilder
    .text('code', 'Entity.DepletionType.Code')
    .required()
    .minLength(1)
    .maxLength(6)
    .build(),
];

export const DEPLETIONTYPE_CONFIG = {
  entityName: 'DepletionType',
  localizationKey: 'Controlling::Entity.DepletionType',
  fields: DEPLETIONTYPE_FIELDS,
  permission: 'ControllingLiquidations.DepletionTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
